import styled from 'styled-components';

const HelperTextContainer = styled.div`
  font-size: 0.875rem;
  line-height: 130%;
  font-weight: 400;
  padding: 0.25rem 0.75rem;
  background-color: transparent;
  color: rgb(219, 27, 27);
`;

const StripeElementContainer = styled.div`
  border: 1px solid rgb(165, 170, 175);
  border-radius: 0.5rem;
  height: 3.5rem;
  width: 100%;
  position: relative;

  && .si-stripe-label {
    padding: 1rem 0.75rem;
    transition: font-size 0.2s ease-in-out, padding 0.2s ease-in-out;
  }
  &&:has(.si-stripe-focused) {
    box-shadow: rgb(0, 0, 0) 0px 0px 0px 1px inset;
    outline: none;
    border-color: rgb(0, 0, 0);
  }

  &&:has(.si-stripe-focused) .si-stripe-label {
    padding: 0.65rem 0px 0rem 0.75rem;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  &&:not(:has(.si-stripe-empty)) .si-stripe-label {
    padding: 0.65rem 0px 0rem 0.75rem;
    font-size: 14px;
  }

  && .si-stripe-base:not(.si-stripe-empty) {
    opacity: 100;
  }

  && .si-stripe-base.si-stripe-focused {
    opacity: 100;
  }

  && .si-stripe-base {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    padding: 1.75rem 0px 0.75rem 0.75rem;
    cursor: text;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
`;

const CardNumberLabel = styled.label`
  padding: 0.65rem 0px 0rem 0.75rem;
  position: absolute;
  color: rgb(110, 118, 125);
  font-size: '14px';
`;

const CardNumberInput = styled.div`
  padding: 1.75rem 0px 0.75rem 0.75rem;
  position: absolute;
  width: 100%;
`;

export const AUIImitationTextField: React.FC<{
  children: React.ReactNode;
  error?: string;
  label: string;
}> = ({ children, error, label }) => {
  return (
    <div>
      <StripeElementContainer>
        <CardNumberLabel className="si-stripe-label">{label}</CardNumberLabel>
        <CardNumberInput>{children}</CardNumberInput>
      </StripeElementContainer>
      {error && (
        <HelperTextContainer>
          {error === 'HIDDEN_CC_ERROR' ? '' : error}
        </HelperTextContainer>
      )}
    </div>
  );
};
